<template>
  <SbButton
    v-if="buttonLabel"
    :is-disabled="disabled"
    :label="buttonLabel"
    variant="secondary"
    size="large"
  />
  <SbIconButton
    v-else
    size="large"
    tooltip-position="top"
    :is-disabled="disabled"
    :label="tooltipLabel"
    :icon="icon"
  />
</template>

<script lang="ts" setup>
import SbButton from '../../Button/SbButton.vue'
import SbIconButton from '../../IconButton/SbIconButton.vue'
import type { IconName } from '../../Icon'

withDefaults(
  defineProps<{
    disabled?: boolean
    icon?: IconName
    tooltipLabel?: string
    buttonLabel?: string
  }>(),
  {
    disabled: false,
    tooltipLabel: '',
    buttonLabel: '',
  },
)
</script>
